const reservation = {
    init: () => {
        $(reservation.init_ready);
    },
    init_ready: () => {

        $('form').validate();
        var $otherPersonBlock = $('#OtherPerson');
        if ($('form #Form_RegisteringOtherPerson').is(':checked')) {
            $otherPersonBlock.show();
        }

        $('form').on("submit", function () {
            if ($(this).valid()) {
                $("#globalLoading").show();
            }
        });

        $('form #Form_RegisteringOtherPerson').change(function () {

            if (!this.checked) {
                $otherPersonBlock.slideUp("fast");
            } else {
                $otherPersonBlock.slideDown("fast");

                //if ($('form #Form_OtherPersonEmail').val() <= 0) {
                //    $('form #Form_OtherPersonEmail').val($("form #Form_Email").val());
                //}
            }
        });

        $("form #Form_Email").on("change", function () {
            if ($('form #Form_OtherPersonEmail').val() <= 0 && $('form #Form_RegisteringOtherPerson').is(":checked")) {
                $('form #Form_OtherPersonEmail').val($(this).val());
            }
        });

        $('form #Form_OtherPersonFullName').select2({
            width: '100%',
            tags: true,
            language: 'cs',
            selectOnClose: true,
            allowClear: true,
            placeholder: "",
            minimumInputLength: 2,
            ajax: {
                url: urlHelper.qualifyURL('Employee/FindEmployee'),
                dataType: 'json',
                delay: 250
            },
            templateResult: function (state) {

                var template = "";
                if (state.position != null)
                    template += " - " + state.position;

                if (state.departmentName != null) {
                    if (template.length > 0)
                        template += ", " + state.departmentName;
                    else
                        template += " - " + state.departmentName;
                }

                return state.text + template;
            }
        });
        $('form #Form_OtherPersonFullName').on('select2:select', function (e) {
            var data = e.params.data;
            if (data.email != undefined) {
                $('form #Form_OtherPersonEmail').val(data.email);
            }
            if (data.employeeLogin != undefined) {
                $('form #Form_OtherEmployeeLogin').val(data.employeeLogin);
            }
        });
        $('form #Form_OtherPersonFullName').on('select2:clear', function (e) {
            $('form #Form_OtherEmployeeLogin').val("");
            $('form #Form_OtherPersonEmail').val($("form #Form_Email").val());
        });
    }
};